import { HelpAdminPage } from '../features/help/HelpAdminPage.tsx';
import { createBrowserRouter, Navigate, Outlet } from 'react-router';
import { useAdminAuth } from './auth-store.ts';
import { LoginPage } from '../features/auth/LoginPage.tsx';
import { AdminLayout } from '../features/shell/AdminLayout.tsx';
import { DashboardPage } from '../features/dashboard/DashboardPage.tsx';
import { BusinessesPage } from '../features/businesses/BusinessesPage.tsx';
import { BusinessDetailPage } from '../features/businesses/BusinessDetailPage.tsx';
import { ConfigAssistantPage } from '../features/businesses/ConfigAssistantPage.tsx';
import { SupportViewPage } from '../features/businesses/SupportViewPage.tsx';
import { UsersPage } from '../features/users/UsersPage.tsx';
import { PlansPage } from '../features/plans/PlansPage.tsx';
import { ProvidersPage } from '../features/providers/ProvidersPage.tsx';
import { IntegrationsPage } from '../features/integrations/IntegrationsPage.tsx';
import { CostsPage } from '../features/costs/CostsPage.tsx';
import { ProfitPage } from '../features/profit/ProfitPage.tsx';
import { SupportPage } from '../features/support/SupportPage.tsx';
import { AuditPage } from '../features/audit/AuditPage.tsx';
import { AlertsPage } from '../features/alerts/AlertsPage.tsx';
import { SettingsPage } from '../features/settings/SettingsPage.tsx';
import { InfraPage } from '../features/infra/InfraPage.tsx';

function Boot() {
  return <div className="k-auth"><span className="k-spinner" aria-label="loading" /></div>;
}
function RequireAdmin() {
  const status = useAdminAuth((s) => s.status);
  if (status === 'booting') return <Boot />;
  if (status === 'anonymous') return <Navigate to="/login" replace />;
  return <Outlet />;
}
function AnonymousOnly() {
  const status = useAdminAuth((s) => s.status);
  if (status === 'booting') return <Boot />;
  if (status === 'authenticated') return <Navigate to="/" replace />;
  return <Outlet />;
}


export const router = createBrowserRouter([
  { element: <AnonymousOnly />, children: [{ path: '/login', element: <LoginPage /> }] },
  {
    element: <RequireAdmin />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'infraestrutura', element: <InfraPage /> },
          { path: 'negocios', element: <BusinessesPage /> },
          { path: 'negocios/:id', element: <BusinessDetailPage /> },
          { path: 'negocios/:id/assistente', element: <ConfigAssistantPage /> },
          { path: 'negocios/:id/suporte', element: <SupportViewPage /> },
          { path: 'usuarios', element: <UsersPage /> },
          { path: 'planos', element: <PlansPage /> },
          { path: 'provedores', element: <ProvidersPage /> },
          { path: 'ia', element: <IntegrationsPage only="ai" /> },
          { path: 'integracoes', element: <IntegrationsPage only="other" /> },
          { path: 'custos', element: <CostsPage /> },
          { path: 'lucros', element: <ProfitPage /> },
          { path: 'suporte', element: <SupportPage /> },
          { path: 'auditoria', element: <AuditPage /> },
          { path: 'alertas', element: <AlertsPage /> },
          { path: 'ajuda', element: <HelpAdminPage /> },
          { path: 'configuracoes', element: <SettingsPage /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
